import ListAltIcon from "@mui/icons-material/ListAlt";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import SensorsIcon from "@mui/icons-material/Sensors";
import SecurityIcon from "@mui/icons-material/Security";
import HubIcon from "@mui/icons-material/Hub";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Toolbar,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo.png";

const navItems = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <SpaceDashboardIcon />,
  },
  {
    label: "Events",
    path: "/events",
    icon: <ListAltIcon />,
  },
  {
    label: "Tickets",
    path: "/tickets",
    icon: <ConfirmationNumberIcon />,
  },
  {
    label: "Source Channel",
    path: "/source-channels",
    icon: <HubIcon />,
  },
  {
    label: "Tap Log",
    path: "/tap-logs",
    icon: <SensorsIcon />,
  },
  {
    label: "Audit Trail",
    path: "/audit-trail",
    icon: <SecurityIcon />,
  },
  {
    label: "Ticket Uploads",
    path: "/ticket-uploads",
    icon: <UploadFileIcon />,
  },
];

const SidebarContent = ({ selectedPath, onNavigate }) => {
  // const isActive = (path) => selectedPath.startsWith(path);
  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Toolbar
        sx={{
          px: 3,
          minHeight: 72,
        }}
      >
        <Box component="img" src={logo} alt="Special Lane CMS logo" sx={{ maxWidth: 160 }} />
      </Toolbar>
      <Box sx={{ flexGrow: 1, overflowY: "auto", py: 2 }}>
        <List
          subheader={
            <ListSubheader
              component="div"
              sx={{
                lineHeight: 1,
                mb: 1,
                px: 3,
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: "0.18em",
                color: "text.secondary",
              }}
            >
              Management
            </ListSubheader>
          }
          sx={{ px: 1 }}
        >
          {navItems.map((item) => {
            const isActive = selectedPath.startsWith(item.path);
            return (
            <ListItemButton
              key={item.path}
              selected={isActive}
              onClick={() => !item.disabled && onNavigate(item.path)}
              disabled={item.disabled}
              sx={{
                mb: 0.75,
                mx: 1,
                borderRadius: 0.5,
                backgroundColor: isActive ? "primary.main" : "transparent",
                color: "#000000",
                "& .MuiListItemText-primary": {
                  fontWeight: 500,
                  fontSize: 14,
                  color: "inherit",
                },
              }}
            >
              <ListItemIcon sx={{ color: "inherit", minWidth: 32 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          );
          })}
        </List>
      </Box>
    </Box>
  );
};

const Sidebar = ({ drawerWidth, mobileOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="sidebar navigation"
    >
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box", borderRadius: 0, },
        }}
      >
        <SidebarContent
          selectedPath={location.pathname}
          onNavigate={(path) => {
            navigate(path);
            onClose();
          }}
        />
      </Drawer>
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            borderRight: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 0,
          },
        }}
      >
        <SidebarContent selectedPath={location.pathname} onNavigate={navigate} />
      </Drawer>
    </Box>
  );
};

export default Sidebar;
